import * as React from 'react'
import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Loading from '../../../components/Loading'
import CommandDialog, { Dismiss } from '../Command/CommandDialog'
import TimeForm from '../../Form/Time/TimeForm'
import FormikCommandButtons from '../../Form/FormikCommandButtons'
import { TimeMutationDto, TimeOverviewDto } from '../../../config/registrationConfig'
import useEntity from '../../../hooks/useEntity'
import useAxios from '../../../hooks/useAxios'
import { EntityParams } from '../../Form/Form'
import { getOnSubmitWithCallback } from '../../Form/FormButtons'
import { InvoiceStatus } from '../../../config/finance/invoiceConfig'
import { TimeAction } from '../../../config/registration/timeConfig'

export default function EditTimeDialog(): ReactElement {
    const axios = useAxios()
    const dispatch = useDispatch()
    const { id } = useParams<EntityParams>()
    const [entity] = useEntity<TimeOverviewDto>(id => ({ url: `/time/${id}` }), id)

    if (!entity.loaded) {
        return <Loading />
    }

    return (
        <CommandDialog dialogContentProps={{ title: 'Tijd registreren' }}>
            {({ onDismiss }: { onDismiss: Dismiss }) => (
                <TimeForm
                    entity={entity}
                    onSubmit={getOnSubmitWithCallback(
                        dispatch,
                        // The invoice form may listen in on these events, therefore Redux is required in this scenario.
                        (values: TimeMutationDto) => ({
                            type: TimeAction.Update,
                            payload: axios.put(`/time/${id}`, values),
                        }),
                        onDismiss,
                    )}
                    useFileContext
                >
                    <FormikCommandButtons
                        dismiss={onDismiss}
                        lockedSave={[InvoiceStatus.Final, InvoiceStatus.Done].includes(entity.data.invoice?.status)}
                    />
                </TimeForm>
            )}
        </CommandDialog>
    )
}
